import React, { useRef, useState } from 'react'

import cx from 'classnames'
import Badge from 'conversations/components/Badge'
import useOnClickOutside from 'conversations/hooks/useOnClickOutside'
import { useDebounce } from 'use-debounce'

import { H3 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import styles from './styles.module.css'

interface Props {
  selectedInboxName: string
  children?: React.ReactNode
  hasSelectDropdown: boolean
  badgeCount: number
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const InboxSwitcher: React.FC<Props> = ({
  selectedInboxName,
  hasSelectDropdown,
  children,
  badgeCount,
  isOpen,
  setIsOpen,
}): JSX.Element => {
  const [isClosing, setIsClosing] = useState(false)
  const [debouncedCount] = useDebounce(badgeCount, 750)
  const selectMenuRef = useRef<HTMLDivElement>(null)
  const close = () => {
    if (isOpen) {
      setIsClosing(true)
      setTimeout(() => {
        setIsClosing(false)
        setIsOpen(false)
      }, 200)
    }
  }

  useOnClickOutside(selectMenuRef, close)

  return (
    <div
      onClick={() => close()}
      ref={selectMenuRef}
      className={cx(styles.container, { [styles.open]: isOpen, [styles.closing]: isClosing })}>
      <div className={styles.inboxSwitcher}>
        <H3 className={styles.selectedInboxName}>{selectedInboxName}</H3>
        {hasSelectDropdown && (
          <span className={styles.inboxDropdown}>
            <Icon height="11" width="11" className={styles.dropdownIcon} name={'arrow-1-right'} />
            {debouncedCount > 0 && (
              <span className={styles.dropdownBadgeDot}>
                <Badge count={0} dot />
              </span>
            )}
          </span>
        )}
      </div>
      <div className={cx(styles.selectMenu)}>{children}</div>
    </div>
  )
}

export default InboxSwitcher
